import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  constructor() { }
  clickablePageNum: Array<number | string> = [];
  @Input() numOfPages: number;
  @Input() currentPage: number;
  @Output() isChangePage = new EventEmitter<any>();

  ngOnInit(): void {
    this.getClickablePageNum();
  }

  ngOnChanges(): void {
    this.getClickablePageNum();
  }

  getClickablePageNum(): void {
    if (this.numOfPages <= 7) {
      [, ...this.clickablePageNum] = Array.from(Array(this.numOfPages + 1).keys());
    } else {
      if (this.currentPage < 5) {
        [, ...this.clickablePageNum] = Array.from(Array(5).keys());
        this.clickablePageNum.push('', this.numOfPages);
      } else if (this.currentPage > this.numOfPages - 4) {
        [, ...this.clickablePageNum] = Array.from(Array(2).keys());
        this.clickablePageNum.push('', this.numOfPages - 3, this.numOfPages - 2, this.numOfPages - 1, this.numOfPages);
      } else {
        [, ...this.clickablePageNum] = [0, 1, ''].concat(Array.from({ length: 3 }, (_, i) => this.currentPage - 1 + i));
        this.clickablePageNum.push('', this.numOfPages);
      }
    }
  }

  onNextButton(e:any): void {
    e.preventDefault();
    if (this.currentPage === this.numOfPages) {
      return;
    }
    this.isChangePage.emit(this.currentPage + 1);
  }

  onPrevButton(e:any): void {
    e.preventDefault();
    if (this.currentPage === 1) {
      return;
    }
    this.isChangePage.emit(this.currentPage - 1);
  }

  onChangeNum(e:any, pageNum: number): void {
    e.preventDefault();
    if (this.currentPage === pageNum) {
      return;
    }
    this.isChangePage.emit(pageNum);
  }

}
